import { render, staticRenderFns } from "./dialog-deposit-pay4Fun.vue?vue&type=template&id=3b5a8bcd&scoped=true"
import script from "./dialog-deposit-pay4Fun.vue?vue&type=script&lang=js"
export * from "./dialog-deposit-pay4Fun.vue?vue&type=script&lang=js"
import style0 from "./dialog-deposit-pay4Fun.vue?vue&type=style&index=0&id=3b5a8bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a8bcd",
  null
  
)

export default component.exports